import * as React from 'react';

import { X } from 'lucide-react';
import type { PlateEditor } from 'platejs/react';
import { IconColors } from 'src/components/icons/icon-utils';

// Re-export everything from AlineMarkdownEditor utils
export * from '../AlineMarkdownEditor/utils';

/** Shared remove icon for chip elements (mentions, links) with consistent sizing */
export const ChipRemoveIcon = () => <X color={IconColors.White} size={10} strokeWidth={3} />;

/** Maximum number of files that can be uploaded at once in the chat editor */
export const MAX_CHAT_UPLOAD_FILES = 20;

// Data attribute keys for Plate elements (chat-specific)
export const plateDataIds = {
  link: 'data-slate-link',
  url: 'data-url',
} as const;

/**
 * Extended PlateEditor interface with chat-specific properties.
 */
export interface ChatPlateEditor extends PlateEditor {
  chatThreadId?: UUID | null;
}

/**
 * Type guard to check if a PlateEditor is a ChatPlateEditor.
 */
export function getIsChatPlateEditor(editor: PlateEditor): editor is ChatPlateEditor {
  return 'chatThreadId' in editor;
}
